import React from 'react';
// import { withRouter} from 'react-router-dom';

import {hasStoredToken} from 'utils/authentication';
import { LoaderRipple } from 'component/loader';
import LandingLayout from 'component/page/landing';
import API, {handleError} from 'utils/xhr';


export default class LoginEmail extends React.Component {
  state = {
    loading: false,
    form_data: {
      email: '',
      invite_code: '',
    },
    show_code: false,
  }

  componentDidMount(){
    if (hasStoredToken()){
      this.props.history.push('/');
    }
  }

  onChange(e){
    const state = this.state;
    state.form_data[e.target.name] = e.target.value;
    this.setState(state);
  }

  runLogin(){
    const url = '/public/login/email';

    var data = this.state.form_data;

    const state = this.state;
    state.loading = true;
    this.setState(state);

    API.post(url, data).then(response => {
      const state = this.state;
      state.loading = false;
      this.setState(state);

    }, (error) => {
      const state = this.state;
      state.loading = false;
      this.setState(state);
      handleError(error);
    });

  }

  sendEmailCode(){
    const url = '/public/login/email';

    var data = this.state.form_data;

    const state = this.state;
    state.loading = true;
    this.setState(state);

    API.post(url, data).then(response => {

      const state = this.state;
      state.loading = false;
      state.show_code = true;
      this.setState(state);

    }, (error) => {
      const state = this.state;
      state.loading = false;
      this.setState(state);
      handleError(error);
    });

  }

  render (){
    return (
      <LandingLayout id="login-invite">

        <div className="login-form highlight-dark-1 rounded p-2">

          <div className="avatar" align="center">
            <span className="fa-stack fa-4x align-items-center">
              <i className="fa fa-circle fa-stack-2x text-secondary"></i>
              <i className="fa fa-at fa-stack-1x fa-inverse"></i>
            </span>
          </div>

          <h2 className="text-center">Email login</h2>

          <div className="m-4">
            <div className="m-2">
              <p className="text-muted">NOTE: Only for <strong>already onboarded</strong> users not using social login</p>
            </div>

            <div className="form-group">
                <div className="">
                  <label className="col-form-label">Your email address: </label>
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    onChange={this.onChange.bind(this)}
                    value={this.state.form_data.email}
                    placeholder="Your email address"/>
                </div>
                {(this.state.show_code)? (
                  <div className="">
                    <label className="col-form-label">Enter login code: </label>
                    <input
                      type="text"
                      className="form-control"
                      name="invite_code"
                      onChange={this.onChange.bind(this)}
                      value={this.state.form_data.invite_code}
                      placeholder="Login code from your email"/>
                    <div className="m-2">
                      <small className="text-danger">If <strong>{this.state.form_data.email}</strong> has been onboarded, it will receive an email from us with an invite code. Please paste the code above OR click on the login link in the email.</small>
                      <small className="text-danger"><strong>NOTE:</strong> If <strong>{this.state.form_data.email}</strong> has <strong>NOT</strong> been onboarded by a DivShow team member, than you will not receive the email code yet. This login is for select Enterprise customers only!</small>
                    </div>
                  </div>
                ): ('')}
              </div>

              <div className="form-group">

                {(this.state.show_code)? (
                  <div className="">
                    <button
                      onClick={this.runLogin.bind(this)}
                      className="btn btn-secondary btn-lg">
                      <span className="">Login <i className="fa fa-sign-in-alt ml-2 "></i></span>
                    </button>
                    <p className="m-2 text-muted">Trouble logging in? <a href="mailto:info@bytebeacon.com">Contact us</a></p>
                  </div>
                ): (
                  <button
                    onClick={this.sendEmailCode.bind(this)}
                    className="btn btn-secondary btn-lg">
                      <span className="">Send login code <i className="fa fa-cog fa-spin fa-lg ml-2"></i></span>
                  </button>
                )}

              </div>

              <LoaderRipple fetching_data={this.state.loading} />

          </div>
        </div>

      </LandingLayout>
    )
  }
}
